<i18n src="./resources/locales.json" />

<template>
  <v-dialog v-model="dialog" persistent max-width="420" content-class="list-selection-dialog">
    <v-card color="surface lighten-1">
      <v-card-title class="header">{{ title }}</v-card-title>

      <div class="search-bar">
        <v-text-field
          v-model="searchString"
          prepend-inner-icon="mdi-magnify"
          single-line
          hide-details
          solo
          flat
          placeholder="Search lists"
          height="40"
          class="search-lists"
        />
      </div>

      <v-list class="dialog-content pa-0" color="var(--v-surface-base)">
        <v-virtual-scroll :items="filteredLists" :item-height="56" :bench="1" :height="460">
          <template v-slot="{ item }">
            <v-list-item @click="() => {}">
              <v-list-item-title>{{ item.name }}</v-list-item-title>
              <v-list-item-action>
                <v-btn icon @click="select(item)">
                  <v-icon>mdi-send</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </template>
        </v-virtual-scroll>
      </v-list>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="cancel()">
          {{ $t('buttons.cancel') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EcsListSelectionDialog',

  data() {
    return {
      title: '',
      searchString: '',
      dialog: false
    };
  },

  computed: {
    ...mapGetters(['filteredContactLists']),

    filteredLists() {
      return this.filteredContactLists(this.searchString);
    }
  },

  mounted() {
    this.$root.$on('open-list-selection-dialog', this.open);
  },

  beforeDestroy() {
    this.$root.$off('open-list-selection-dialog');
  },

  methods: {
    open({ title, action }) {
      this.dialog = true;
      this.title = title || this.$t('header.title');
      this.$once('selected', selection => {
        action(selection);
        this.dialog = false;
      });
    },

    select(list) {
      this.$emit('selected', [list]);
    },

    cancel() {
      this.$emit('selected', []);
    }
  }
};
</script>

<style scoped lang="scss">
.search-bar {
  background-color: var(--v-surface-lighten1);
  padding: 4px 16px 16px;
}

.dialog-content {
  height: 460px;
}
</style>

<style lang="scss">
.search-lists .v-input__control {
  min-height: 40px !important;
}

.search-lists .v-input__slot {
  background-color: var(--v-surface-base) !important;
  border-radius: 20px !important;
  min-height: 40px;
}
</style>
